<template>
  <div class="container__forum-header">
    <div class="d-flex py-3">
      <span ref="text__forum-topic" class="text__forum-topic text__topic-title">{{
        forum.topic
      }}</span>
    </div>

    <div class="d-flex py-3 flex-row">
      <forum-user
        ref="forum__user"
        class="lu-owner-detail"
        :forum-date="forum.timestamp"
        :user-forum="forumOwner.user"
        :learning-unit="learningUnit"
      >
      </forum-user>

      <div v-if="$currentUser.isOwnerOf(learningUnitId)" class="ml-auto ellipsis__forum-header">
        <base-ellipsis ref="icon__dropdown-menu" class="icon__dropdown-menu btn-dropdown">
          <b-dropdown-item
            ref="dropdown-menu__edit"
            class="dropdown-menu__edit"
            :to="editForumPage"
          >
            Edit
          </b-dropdown-item>
        </base-ellipsis>
      </div>
    </div>

    <div class="d-flex pb-3">
      <base-text-editor-display class="m-0 p-0">
        <span
          v-if="forum.description"
          ref="text__forum-description"
          v-safe-html="forum.description"
          class="text__forum-description text__description"
        ></span>

        <span
          v-else
          ref="text__forum-default-description"
          class="text__forum-default-description text__description text-black-50"
        >
          To 4LifelongLearners! This is for sharing your insights, ask questions, and engage in idea
          exchange related to the topic at hand.
        </span>
      </base-text-editor-display>
    </div>

    <forum-thumbnail-group
      v-if="forum.images && forum.images.length"
      :key="`thumbnail-group-header-${forum.id}`"
      :key-id="forum.id"
      class="py-3"
      :images="forum.images"
      :maximum-display-images="3"
    ></forum-thumbnail-group>

    <div class="d-flex align-items-baseline pb-3">
      <div class="container__forum-comment-like">
        <like-button :content="forum.liked" :count-like="forum.count_likes" @click:liked="like" />

        <div class="button__comment d-flex align-items-center p-0">
          <font-awesome-icon :icon="{ prefix: 'far', iconName: 'message' }" />

          <span ref="text__total-comment" class="ml-2" v-text="forum.count_replies"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Forum from '@/models/Forum';
import LearningUnitMember from '@/models/LearningUnitMember';
import UserRole from '@/models/UserRole';
import LearningUnit from '@/models/LearningUnit';
import ForumLiker from '@/models/ForumLiker';
import BaseEllipsis from '@/components/base-components/BaseEllipsis';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import ForumThumbnailGroup from '@/components/Forum/ForumThumbnailGroup';
import ForumUser from '@/components/Forum/ForumUser.vue';
import LikeButton from '@/views/Feed/components/LikeButton.vue';

export default {
  components: {
    BaseEllipsis,
    BaseTextEditorDisplay,
    ForumUser,
    ForumThumbnailGroup,
    LikeButton
  },
  props: {
    learningUnitId: {
      type: Number,
      required: true
    },
    forum: {
      type: Forum,
      required: true
    },
    forumOwner: {
      type: LearningUnitMember,
      required: true
    }
  },
  computed: {
    editForumPage() {
      const { learningUnitId, forum } = this,
        { id: forumId } = forum;

      return {
        name: 'forum-edit',
        params: {
          learningUnitId,
          forumId
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    },
    userFullName() {
      return `${this.forumOwner.user.firstname} ${this.forumOwner.user.lastname}`;
    },
    ownerRole() {
      const ownerRole = UserRole.learningUnitOwner();

      switch (this.forumOwner.user_role) {
        case ownerRole.id:
          return 'Expert';
        default:
          return null;
      }
    },
    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    }
  },
  methods: {
    async like(content) {
      const { forum } = this,
        { id: forumId } = forum;

      if (!content) {
        await Forum.api().likeForum(forumId);
      } else {
        await Forum.api().unlikeForum(forumId);
        ForumLiker.delete(content.id);
      }
    }
  }
};
</script>

<style scoped lang="css">
.container__forum-header {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d1d2db;
}

.text__forum-topic {
  color: #3b3e66;
  font-weight: 600;
  font-size: 1.25rem;
}

.container__forum-comment-like {
  display: flex;
  flex-direction: row;
  gap: 0 1rem;
}
</style>
